export default __webpack_public_path__ + "static/media/galaxy.3e34256a.png";